import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

interface GlobalState {
  sidebarState: 'expanded' | 'collapsed'
  setSidebarState: (state: 'expanded' | 'collapsed') => void
  filtersMenuVisible: boolean
  setFiltersMenuVisible: (visible: boolean) => void
}

const useGlobalStore = create<GlobalState>()(
  devtools(
    persist(
      (set) => ({
        sidebarState: 'expanded',
        setSidebarState: (state: 'expanded' | 'collapsed') =>
          set({ sidebarState: state }),
        filtersMenuVisible: true,
        setFiltersMenuVisible: (visible: boolean) =>
          set({ filtersMenuVisible: visible }),
      }),
      {
        name: 'global-storage',
      }
    )
  )
)

export { useGlobalStore }
